import { differenceInDays, format, parse, isAfter } from 'date-fns';

export type AmPm = 'AM' | 'PM';

export type TimeParts = { hours: string; minutes: string; isPm: boolean };

export const validateDate = (value: string): string | null => {
  if (/[^\d/]/.test(value)) {
    return 'Invalid format. Please use "/" as the separator.';
  }
  const parts = value.split('/');
  if (parts.length !== 3) {
    return 'Invalid format. Please enter the date in DD/MM/YYYY format.';
  }
  const [day, month, year] = parts;
  if (!/^(0[1-9]|[12][0-9]|3[01])$/.test(day)) {
    return 'Invalid day. Please enter a valid day (DD) between 01 and 31.';
  }
  if (!/^(0[1-9]|1[0-2])$/.test(month)) {
    return 'Invalid month. Please enter a valid month (MM) between 01 and 12.';
  }
  if (!/^\d{4}$/.test(year)) {
    return 'Invalid year. Please enter a valid year (YYYY) with four digits.';
  }
  return null;
};

export function pad(v: string) {
  if (isNaN(parseInt(v))) {
    return v;
  }
  if (v.length == 1) {
    return `0${v}`;
  }
  return v;
}

export function validateRanges(start?: Date, end?: Date): string | undefined {
  if (!start || !end) {
    return;
  }
  const now = new Date();
  if (isAfter(end, now)) {
    return 'End date cannot be in the future';
  }
  if (isAfter(start, now)) {
    return 'Start date cannot be in the future';
  }
  if (isAfter(start, end)) {
    return 'End date must be after start';
  }
  if (differenceInDays(end, start) > 31) {
    return 'Range cannot exceed 31 days';
  }
}

export function dateToDateString(date: Date | string | undefined): string | undefined {
  if (!date) {
    return undefined;
  }
  return format(new Date(date), 'yyyy/MM/dd');
}

export function dateStringToDate(str: string) {
  if (!str) {
    return undefined;
  }
  return parse(str, 'yyyy/MM/dd', new Date());
}

export function dateToTimeString(date: Date | string | undefined): string | undefined {
  if (!date) {
    return date;
  }
  return format(new Date(date), 'HH:mm:a..aa');
}

export function dateToTimeParts(date: Date | string | undefined): TimeParts {
  if (!date) {
    return { minutes: '', hours: '', isPm: true };
  }
  const d = new Date(date);
  return {
    minutes: d.getMinutes().toString(),
    hours: (d.getHours() % 12).toString(),
    isPm: d.getHours() >= 12,
  };
}
export function timePartToDate(baseDate: Date, timeParts: TimeParts) {
  const d = new Date(baseDate);
  d.setHours(parseInt(timeParts.hours) + (timeParts.isPm ? 12 : 0));
  d.setMinutes(parseInt(timeParts.minutes));
  return d;
}
